module.exports = __webpack_public_path__ + "img/AL.94a250f4.png";